import { Box, Button, CircularProgress, Typography } from '@mui/material';

import { ReactComponent as InfoIcon } from '../../../../../assets/icons/main/info-icon.svg';
import { ReactComponent as ScanIcon } from '../../../../../assets/icons/main/scan-icon.svg';
import get from 'lodash/get';
// import { isEmpty } from 'lodash';

const Styles = {
  stepBtnsWrapper: { display: 'flex', justifyContent: 'space-between', gap: 3 }, //justifyContent: 'end',
  serverPropsStep: {
    wrapper: { display: 'flex', flexDirection: 'column' },
    scanBtn: { alignSelf: 'end' },
    infoWrapper: { display: 'flex', alignItems: 'center', mt: 3, mb: 4 },
    info: { fontSize: '16px', fontWeight: 600, ml: 1 },
  },
  messagesStep: {
    wrapper: { display: 'flex', flexDirection: 'column' },
    backBtn: { alignSelf: 'end' },
    strategyFormLabel: { color: '#434D67 !important', fontWeight: 400, fontSize: '16px' },
    formControlLabel: {
      mr: 1,
      '& .MuiFormControlLabel-label': { color: '#434D67', fontWeight: 400, fontSize: '16px' },
    },
    formControl: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      borderBottom: '1px solid #D9DFED',
      pb: 2,
      marginBlock: 3,
    },
    radioGroup: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      flexWrap: 'nowrap',
    },
    radio: { color: '#5C85FF' },
  },
};

const CustomComponent = ({
  activeCategory,
  categories,
  handleStep,
  info,
  enabled,
  isScannable,
  uischema,
  schema,
  assetCompsData,
  isScanningTags,
  onStopScanning,
  disableScanStop,
}: any) => {
  const nextAction = get(uischema, `elements.${activeCategory}.rule.action`, '');

  return (
    <Box>
      <Box sx={Styles.stepBtnsWrapper}>
        <Box></Box>
        <Box sx={{ display: 'flex', gap: 2 }}>
          {uischema?.elements &&
            uischema.elements[activeCategory - 1] &&
            uischema.elements[activeCategory - 1]?.category && (
              <Button
                variant='outlined'
                disabled={!get(assetCompsData, 'component.enabled', false) || !enabled}
                onClick={(e) => handleStep(activeCategory - 1)}
              >
                Back
              </Button>
            )}
          {uischema?.elements &&
            uischema.elements[activeCategory + 1] &&
            uischema.elements[activeCategory + 1]?.category && (
              <>
                {isScanningTags ? (
                  <Button
                    variant='contained'
                    onClick={onStopScanning}
                    startIcon={<CircularProgress size={16} sx={{ color: '#fff' }} />}
                    disabled={disableScanStop[assetCompsData.activeNode?.id]}
                  >
                    STOP
                  </Button>
                ) : (
                  <Button
                    variant='contained'
                    onClick={(e) => handleStep(activeCategory + 1, nextAction)}
                    // disabled={isEmpty(assetCompsData) || assetCompsData?.isEnabled}
                    disabled={
                      !get(assetCompsData, 'component.enabled', false) ||
                      !enabled ||
                      disableScanStop[assetCompsData.activeNode?.id]
                    }
                    startIcon={nextAction && <ScanIcon style={{ width: '24px', height: '24px' }} />}
                  >
                    {get(uischema, `elements.${activeCategory}.rule.nextButtonLabel`, 'Next')}
                  </Button>
                )}
              </>
            )}
        </Box>
      </Box>
      {info && (
        <Typography component='p' sx={Styles.serverPropsStep.infoWrapper}>
          <InfoIcon />
          <Typography component='span' sx={Styles.serverPropsStep.info}>
            {info}
          </Typography>
        </Typography>
      )}
    </Box>
  );
};

export default CustomComponent;
